<script>
import appConfig from "@/app.config";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Form wizard component
 */
export default {
  page: {
    title: "Gracias por tu compra",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Gracias por tu compra",
      items: [
      ],
      orderData: {
        code: "",
        created_at: "",
        total_paid: "",
        limit_date: "",
      }
    };
  },
  created() {
    this.orderData = {
      code: this.$route.query.code || "",
      created_at: this.$route.query.created_at || "",
      total_paid: this.$route.query.total_paid || "",
      limit_date: this.$route.query.limit_date || "",
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row store-confirm-page">
      <div class="col-xl-7 col-lg-9 mx-auto">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4 p-md-5">
            <div class="text-center mb-4">
              <div class="thank-you-check mx-auto mb-3">
                <i class="fas fa-check"></i>
              </div>
              <h4 class="mb-2">Gracias por tu compra</h4>
              <p class="text-muted mb-0">
                Tu pedido se creó correctamente.
              </p>
            </div>

            <div class="thank-you-summary mb-4">
              <h6 class="text-muted font-weight-bold mb-3">Resumen del pedido</h6>

              <div class="summary-row">
                <span class="summary-label">Referencia:</span>
                <span class="summary-value">{{ orderData.code || "-" }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Fecha:</span>
                <span class="summary-value">{{ orderData.created_at || "-" }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Monto:</span>
                <span class="summary-value">{{ orderData.total_paid || "-" | currency }}</span>
              </div>
              <div v-if="orderData.limit_date" class="summary-row">
                <span class="summary-label">Fecha límite de pago:</span>
                <span class="summary-value text-danger">{{ orderData.limit_date }}</span>
              </div>
            </div>

            <div class="thank-you-actions d-flex flex-column flex-md-row justify-content-end">
              <router-link
                to="/orders"
                tag="button"
                class="btn btn-primary mr-md-2"
              >
                Ir a mis paquetes
              </router-link>
              <router-link
                to="/store"
                tag="button"
                class="btn btn-secondary mt-2 mt-md-0"
              >
                Seguir comprando
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>



